import { createSelector, createSlice } from '@reduxjs/toolkit';
import { sortItems } from '@utils/functions.js';

const initialState = {
  isLoading: false,
  isActive: false,
  id: 0,
  uid: 0,
  sid: 0,

  blockContent: {
    items: [],
    heading: {
      title: '',
      description: '',
      textAlign: 'left',
      image: '',
      divider: '',
      position: '',
    },
  },
  blockDesign: {
    layout: '4',
    view: 'grid',
    columns: 2,
  },
  itemDesign: {},
  containerDesign: {},
};

export const nftSlice = createSlice({
  name: 'nft',
  initialState,
  reducers: {
    nftStore: (state, action) => {
      const { id, isActive, sid, uid, data } = action.payload;

      const block = data ?? {};
      const { blockContent, blockDesign } = block;
      const { itemDesign, containerDesign } = blockDesign;

      state.isLoading = false;
      state.id = id ?? 0;
      state.isActive = isActive;
      state.sid = sid;
      state.uid = uid;

      state.itemDesign = itemDesign ?? {};
      state.containerDesign = containerDesign ?? {};

      state.blockContent = {
        items: blockContent.items ?? [],
        heading: {
          title: blockContent.heading.title ?? '',
          description: blockContent.heading.description ?? '',
          textAlign: blockContent.heading.textAlign ?? 'left',
          image: blockContent.heading.image ?? '',
          divider: blockContent.heading.divider ?? '',
          position: blockContent.heading.position ?? '',
        },
      };
      state.blockDesign = {
        layout: blockDesign.layout ?? '4',
        view: blockDesign.view ?? 'grid',
        columns: blockDesign.columns ?? 2,
      };
    },
    nftClear: () => initialState,

    nftUpdateIsLoading: (state, action) => {
      state.isLoading = action.payload;
    },
    nftUpdateIsActive: (state, action) => {
      state.isActive = action.payload;
    },
    nftUpdateBlockContent: (state, action) => {
      state.blockContent = action.payload;
    },
    nftUpdateBlockDesign: (state, action) => {
      state.blockDesign = action.payload;
    },
  },
});

export const { nftStore, nftClear, nftUpdateIsLoading, nftUpdateIsActive, nftUpdateBlockContent, nftUpdateBlockDesign } = nftSlice.actions;

export const selectNftIsLoading = (state) => state.nft.isLoading;

export const selectNftId = (state) => state.nft.id;
export const selectNftUID = (state) => state.nft.uid;
export const selectNftSID = (state) => state.nft.sid;

export const selectNftBlockContent = (state) => state.nft.blockContent;
export const selectNftBlockDesign = (state) => state.nft.blockDesign;
export const selectNftSortItems = createSelector([selectNftBlockContent], ({ items }) => {
  return sortItems(items);
});
export const selectNftItemDesign = (state) => state.nft.itemDesign;
export const selectNftContainerDesign = (state) => state.nft.containerDesign;

export default nftSlice.reducer;
